import locales from './locales/ca-fr.json';

export default {
  ...locales,
  app_title: 'Initiateur',

  locales_en_US: 'Anglais (US)',
  locales_en_CA: 'Anglais (CA)',
  locales_fr_CA: 'Français (CA)',
  locales_es_US: 'Espagnol (US)',

  actions_back: 'Retour',
  actions_continue: 'Continuer',

  about_pageTitle: 'Sur',
  home_pageTitle: "Page d'accueil",
  onexExamples_pageTitle: "Exemples d'OneX",
};
